import * as prismicH from '@prismicio/helpers'
import Head from 'next/head'
import prismic, { predicate } from 'services/prismic'

// import Debug from 'components/Debug'
import ArticleCard from 'components/ArticleCard'
import Header from 'components/Header'
import JournalSections from 'components/JournalSections'
import Link from 'components/Link'
import Pagination from 'components/Pagination'
import Spacer from 'components/Spacer'

import { Articles, CategoryHeader, Column, Columns } from './[uid].style'

const prismicArticleToArticleCardProps = ({ uid, data }) => {
  return {
    layout: 'vertical',
    handle: uid,
    imageUrl: data.cover_image?.url,
    category: data.category?.data?.title,
    title: data.title,
    excerpt: prismicH.asHTML(data.summary),
  }
}

const prismicCategoriesToJournalSectionProps = (categories) => {
  return categories.map(({ uid, data: { title } }) => ({ title, slug: uid }))
}

const pluralizedTitles = {
  'Artisan Spotlight': 'Artisan Spotlight',
  Event: 'Events',
  'Guest Article': 'Guest Articles',
  Guide: 'Guides',
  Introducing: 'Introducing',
  Lookbook: 'Lookbooks',
  Photostory: 'Photostories',
  'Product Spotlight': 'Product Spotlights',
}

export default function Section({ category, articles, categories }) {
  const header = pluralizedTitles[category.data.title] || category.data.title

  return (
    <>
      <Head>
        <title>{header}</title>
      </Head>
      <CategoryHeader>
        <Header>{header}</Header>
        <Link text="View all articles" href="/journal" />
      </CategoryHeader>
      <Articles>
        <Columns>
          {articles.results.map(prismicArticleToArticleCardProps).map((props) => (
            <Column key={props.handle}>
              <ArticleCard {...props} />
            </Column>
          ))}
        </Columns>
        <Spacer y={8} />
        <Pagination page={articles.page} totalPages={articles.total_pages} />
      </Articles>
      <Spacer y={16} />
      <JournalSections sections={prismicCategoriesToJournalSectionProps(categories)} selectedSlug={category.uid} />
    </>
  )
}

export async function getServerSideProps({ params, query }) {
  const page = query.page || 1

  const category = await prismic.getByUID('article_category', params.uid)

  const articles = await prismic.get({
    predicates: [predicate.at('document.type', 'article'), predicate.at('my.article.category', category.id)],
    fetch: ['article.published_at', 'article.title', 'article.cover_image', 'article.category', 'article.summary'],
    fetchLinks: 'article_category.title',
    orderings: {
      field: 'my.article.published_at',
      direction: 'desc',
    },
    pageSize: 9,
    page,
  })

  const categories = await prismic.getAllByType('article_category', {
    orderings: {
      field: 'my.article_category.title',
    },
  })

  return {
    props: {
      category,
      categories,
      articles,
    },
  }
}
